import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  skeleton: {
    opacity: 0.5,
    transform: 'scale(1)',
  },
}));
